module.exports = __webpack_public_path__ + "img/BDA_Logo.58e89715.svg";